import { Routes, Route } from "react-router-dom";
import { lazy, Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";

// import {
//   onAuthStateChangedListener,
//   createUserDocumentFromAuth,
//   getUserData,
//   getCurrentUser,
// } from "./utils/firebase/firebase.utils";

import { checkUserSession } from "./store/user/user.action";
import Spinner from "./components/spinner/spinner.component";

const Home = lazy(() => import("./routes/home/home.component"));
const Navigation = lazy(() => import("./routes/navigation/navigation.component"));
const Authentication = lazy(() =>
  import("./routes/authentication/authentication.component")
);
const Shop = lazy(() => import("./routes/shop/shop.component"));
const Checkout = lazy(() => import("./routes/checkout/checkout.component"));

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // const setUser = async (user) => {
    //   var userData = await getUserData(user);
    //   dispatch(setCurrentUser(userData));
    // };

    // const unsubscribe = onAuthStateChangedListener((user) => {
    //   if (user) createUserDocumentFromAuth(user);
    //   setUser(user);
    // });
    // return unsubscribe;

    // Using Saga
    dispatch(checkUserSession());
  }, []);

  return (
    <Suspense fallback={<Spinner />}>
      <Routes>
        <Route path="/" element={<Navigation />}>
          <Route index element={<Home />} />
          <Route path="shop/*" element={<Shop />} />
          <Route path="auth" element={<Authentication />} />
          <Route path="checkout" element={<Checkout />} />
        </Route>
      </Routes>
    </Suspense>
  );
};

export default App;
